// @flow

import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';

import {
    SCREEN_SHARING_ERROR
} from './actionTypes';

/**
 * The default state.
 */
const DEFAULT_STATE = {
    error: null
};

ReducerRegistry.register('wildix/features/tracks', (state = DEFAULT_STATE, action) => {

    switch (action.type) {

    case SCREEN_SHARING_ERROR:
        return {
            ...state,
            error: action.error
        };
    }

    return state;
});
